import { ColorTheme, useAppSettingsStore } from "@/store/appSettings.store";
import { ThemeToggleSwitch } from "./ThemeToggleSwitch";
import { shallow } from "zustand/shallow";

export const ThemeToggle = (): JSX.Element => {
  const { theme, toggleTheme } = useAppSettingsStore(
    (state) => ({
      theme: state.theme,
      toggleTheme: state.toggleTheme,
    }),
    shallow
  );

  return (
    <ThemeToggleSwitch
      checked={theme == ColorTheme.Dark}
      onChange={toggleTheme}
    />
  );
};
